module.exports = __webpack_public_path__ + "img/sdg_pt-pt_(8).737ab54d.png";